/**
 * #MT-7546968 — modal detalhe Countback (consulta, padrão sial-detail).
 */

function syncCountbackDetail(root) {
	if (!root) return;
	root.querySelectorAll('[data-sdp-from]').forEach((dd) => {
		const sel = dd.getAttribute('data-sdp-from');
		const el = root.querySelector(sel);
		let v = el ? (el.value || el.textContent || '') : '';
		dd.textContent = v || '—';
	});
	const title = root.querySelector('[data-sdp="product"]');
	const skuEl = root.querySelector('#cb_product_sku');
	const nameEl = root.querySelector('#cb_product_name');
	if (title) {
		const sku = skuEl?.value || '';
		const name = nameEl?.value || '';
		title.textContent = sku ? `${sku} — ${name || '—'}` : (name || '—');
	}
	const badge = root.querySelector('[data-sdp="status"]');
	const st = root.querySelector('#cb_status')?.value || '';
	if (badge) {
		badge.textContent = st || '—';
		badge.className = 'sdp-badge';
		if (st === 'BLOQUEADO_AUDITORIA') badge.classList.add('sdp-badge--blocked');
		else if (st === 'LIBERADO_GESTOR' || st === 'OK') badge.classList.add('sdp-badge--free');
		else badge.classList.add('sdp-badge--other');
	}
	['picked', 'expected', 'informed', 'diff'].forEach((k) => {
		const src = root.querySelector(`#cb_${k === 'picked' ? 'picked_quantity' : k === 'expected' ? 'expected_remaining_quantity' : k === 'informed' ? 'informed_remaining_quantity' : 'difference_quantity'}`);
		const dst = root.querySelector(`[data-sdp="kpi-${k}"]`);
		if (dst) dst.textContent = src?.value ?? '0';
	});
	const histRaw = root.querySelector('#cb_history_json')?.value || '[]';
	const tbody = root.querySelector('#cb_history_body');
	if (!tbody) return;
	let hist = [];
	try { hist = JSON.parse(histRaw); } catch (_) { hist = []; }
	if (!Array.isArray(hist) || !hist.length) {
		tbody.innerHTML = '<tr><td colspan="6">Sem histórico</td></tr>';
		return;
	}
	tbody.innerHTML = hist.map((h) => {
		const dt = h.created_on ? new Date(h.created_on).toLocaleString('pt-BR') : '';
		return `<tr>
			<td>${h.attempt_number ?? ''}</td>
			<td>${h.status ?? ''}</td>
			<td>${h.picked_quantity ?? ''}</td>
			<td>${h.expected_remaining_quantity ?? ''}</td>
			<td>${h.informed_remaining_quantity ?? ''}</td>
			<td>${dt}</td>
		</tr>`;
	}).join('');
}

export default {
	html: `
		<form id="output-picking-countback-detail" class="form sial-modal-form sial-detail" autocomplete="off">
			<input type="hidden" id="company_id" class="sdp-bind">
			<input type="hidden" id="id" class="sdp-bind">
			<input type="hidden" id="cb_product_sku" class="sdp-bind">
			<input type="hidden" id="cb_product_name" class="sdp-bind">
			<input type="hidden" id="cb_status" class="sdp-bind">
			<input type="hidden" id="cb_picked_quantity" class="sdp-bind">
			<input type="hidden" id="cb_expected_remaining_quantity" class="sdp-bind">
			<input type="hidden" id="cb_informed_remaining_quantity" class="sdp-bind">
			<input type="hidden" id="cb_difference_quantity" class="sdp-bind">
			<input type="hidden" id="cb_output_id" class="sdp-bind">
			<input type="hidden" id="cb_order_id" class="sdp-bind">
			<input type="hidden" id="cb_lot_number" class="sdp-bind">
			<input type="hidden" id="cb_location_code" class="sdp-bind">
			<input type="hidden" id="cb_operator_name" class="sdp-bind">
			<input type="hidden" id="cb_created_on" class="sdp-bind">
			<input type="hidden" id="cb_attempt_number" class="sdp-bind">
			<input type="hidden" id="cb_resolution_note" class="sdp-bind">
			<input type="hidden" id="cb_resolved_by_name" class="sdp-bind">
			<input type="hidden" id="cb_resolved_at" class="sdp-bind">
			<input type="hidden" id="cb_company_nick" class="sdp-bind">
			<input type="hidden" id="cb_history_json" class="sdp-bind">
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon" aria-hidden="true">CB</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Detalhe Countback</p>
						<h2 class="sdp-title" data-sdp="product">—</h2>
						<div class="sdp-meta">
							<span>Empresa: <b data-sdp-from="#cb_company_nick">—</b></span>
							<span>Saída: <b data-sdp-from="#cb_output_id">—</b></span>
							<span>Pedido: <b data-sdp-from="#cb_order_id">—</b></span>
							<span>Status: <span class="sdp-badge sdp-badge--other" data-sdp="status">—</span></span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">×</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo Countback">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">Qtd. separada</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-picked">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">Esperado restante</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-expected">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">Informado</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-informed">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--blocked">
					<div class="sdp-kpi-label">Diferença</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-diff">0</span></div>
				</div>
			</section>
			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Ocorrência</h3>
					<dl class="sdp-dl">
						<dt>Tentativa</dt><dd data-sdp-from="#cb_attempt_number"></dd>
						<dt>Lote</dt><dd data-sdp-from="#cb_lot_number"></dd>
						<dt>Posição</dt><dd data-sdp-from="#cb_location_code"></dd>
						<dt>Operador</dt><dd data-sdp-from="#cb_operator_name"></dd>
						<dt>Data/hora</dt><dd data-sdp-from="#cb_created_on"></dd>
					</dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">Resolução</h3>
					<dl class="sdp-dl">
						<dt>Resolvido por</dt><dd data-sdp-from="#cb_resolved_by_name"></dd>
						<dt>Resolvido em</dt><dd data-sdp-from="#cb_resolved_at"></dd>
						<dt>Observação</dt><dd data-sdp-from="#cb_resolution_note"></dd>
					</dl>
				</div>
			</section>
			<section class="sdp-block" style="margin-top:0.75rem">
				<h3 class="sdp-block-title">Histórico de tentativas</h3>
				<table class="view" style="width:100%;font-size:0.9em">
					<thead>
						<tr>
							<th>Tent.</th><th>Status</th><th>Sep.</th><th>Esp.</th><th>Inf.</th><th>Quando</th>
						</tr>
					</thead>
					<tbody id="cb_history_body"></tbody>
				</table>
			</section>
			<div class="sdp-foot">
				<button type="button" class="bn_Escape button">Fechar</button>
			</div>
		</form>
	`,
	form: {
		selector: '#output-picking-countback-detail',
		async afterEditSetValues() {
			const root = document.querySelector('#output-picking-countback-detail');
			syncCountbackDetail(root);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [] },
		{ properties: { selector: '#id' }, types: [] },
		{ properties: { selector: '#cb_product_sku' }, types: [] },
		{ properties: { selector: '#cb_product_name' }, types: [] },
		{ properties: { selector: '#cb_status' }, types: [] },
		{ properties: { selector: '#cb_picked_quantity' }, types: [] },
		{ properties: { selector: '#cb_expected_remaining_quantity' }, types: [] },
		{ properties: { selector: '#cb_informed_remaining_quantity' }, types: [] },
		{ properties: { selector: '#cb_difference_quantity' }, types: [] },
		{ properties: { selector: '#cb_output_id' }, types: [] },
		{ properties: { selector: '#cb_order_id' }, types: [] },
		{ properties: { selector: '#cb_lot_number' }, types: [] },
		{ properties: { selector: '#cb_location_code' }, types: [] },
		{ properties: { selector: '#cb_operator_name' }, types: [] },
		{ properties: { selector: '#cb_created_on' }, types: [] },
		{ properties: { selector: '#cb_attempt_number' }, types: [] },
		{ properties: { selector: '#cb_resolution_note' }, types: [] },
		{ properties: { selector: '#cb_resolved_by_name' }, types: [] },
		{ properties: { selector: '#cb_resolved_at' }, types: [] },
		{ properties: { selector: '#cb_company_nick' }, types: [] },
		{ properties: { selector: '#cb_history_json' }, types: [] },
	],
};
